export const RESET_STATE = 'RESET_STATE'
export const ADD_FOLDER = 'ADD_FOLDER'
export const ADD_AND_SELECT_FOLDER = 'ADD_AND_SELECT_FOLDER'
export const ADD_TEXT_NODE = 'ADD_TEXT_NODE'
export const ADD_AND_SELECT_TEXT_NODE = 'ADD_AND_SELECT_TEXT_NODE'
export const ADD_UPLOADING_IMAGE_NODE = 'ADD_UPLOADING_IMAGE_NODE'
export const MOVE_NODE = 'MOVE_NODE'
export const REMOVE_NODE = 'REMOVE_NODE'
export const TOGGLE_EXPANDED = 'TOGGLE_EXPANDED'
export const CREATE_CONTENT = 'CREATE_CONTENT'
export const UPDATE_CONTENT_COLLECTION = 'UPDATE_CONTENT_COLLECTION'
export const DELETE_CONTENT = 'DELETE_CONTENT'
export const SELECT_NODE_ID = 'SELECT_NODE_ID'
export const SELECT_PARENT_FOLDER = 'SELECT_PARENT_FOLDER'
export const END_EDITING_CONTENT_NODE = 'END_EDITING_CONTENT_NODE'
export const UNDO_CONTENT_CHANGE = 'UNDO_CONTENT_CHANGE'
export const REDO_CONTENT_CHANGE = 'REDO_CONTENT_CHANGE'
export const SET_NOT_EDITING = 'SET_NOT_EDITING'
export const SET_TITLE = 'SET_TITLE'
export const SET_ICON = 'SET_ICON'
export const SET_TEXT = 'SET_TEXT'
export const SET_UPLOADING_IMAGE = 'SET_UPLOADING_IMAGE'
export const REMOVE_UPLOADING = 'REMOVE_UPLOADING'
export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS'
export const ADD_RECEIVED_DOCUMENT = 'ADD_RECEIVED_DOCUMENT'
export const REMOVE_RECEIVED_DOCUMENT = 'REMOVE_RECEIVED_DOCUMENT'
export const SET_BOARDS_ORDER = 'SET_BOARDS_ORDER'
export const SET_USER_CONTENT_SETTINGS = 'SET_USER_CONTENT_SETTINGS'

export const resetState = () => ({
  type: RESET_STATE,
})

export const addFolder = (parentId) => ({
  type: ADD_FOLDER,
  parentId,
})

export const addAndSelectFolder = (parentId) => ({
  type: ADD_AND_SELECT_FOLDER,
  parentId,
})

export const addTextNode = (parentId) => ({
  type: ADD_TEXT_NODE,
  parentId,
})

export const addAndSelectTextNode = (parentId) => ({
  type: ADD_AND_SELECT_TEXT_NODE,
  parentId,
})

export const addUploadingImageNode = (parentId, image) => ({
  type: ADD_UPLOADING_IMAGE_NODE,
  parentId,
  image,
})

export const moveNode = (nodeId, newIndex) => ({
  type: MOVE_NODE,
  nodeId,
  newIndex,
})

export const removeNode = (nodeId) => ({
  type: REMOVE_NODE,
  nodeId,
})

export const toggleExpanded = (folderId, contentId) => ({
  type: TOGGLE_EXPANDED,
  folderId,
  contentId,
})

export const createContent = (contentId, userId) => ({
  type: CREATE_CONTENT,
  contentId,
  userId,
})

export const updateContentCollection = (modified, removed) => ({
  type: UPDATE_CONTENT_COLLECTION,
  modified,
  removed,
})

export const deleteContent = (contentId) => ({
  type: DELETE_CONTENT,
  contentId,
})

export const selectNodeId = (nodeId, contentId) => ({
  type: SELECT_NODE_ID,
  nodeId,
  contentId,
})

export const selectParentFolder = () => ({
  type: SELECT_PARENT_FOLDER,
})

export const endEditingContentNode = () => ({
  type: END_EDITING_CONTENT_NODE,
})

export const undoContentChange = () => ({
  type: UNDO_CONTENT_CHANGE,
})

export const redoContentChange = () => ({
  type: REDO_CONTENT_CHANGE,
})

export const setNotEditing = () => ({
  type: SET_NOT_EDITING,
})

export const setTitle = (nodeId, title, editing) => ({
  type: SET_TITLE,
  nodeId,
  title,
  editing,
})

export const setIcon = (nodeId, icon) => ({
  type: SET_ICON,
  nodeId,
  icon,
})

export const setText = (nodeId, text, editing) => ({
  type: SET_TEXT,
  nodeId,
  text,
  editing,
})

export const setUploadingImage = (nodeId, image) => ({
  type: SET_UPLOADING_IMAGE,
  nodeId,
  image,
})

export const removeUploading = (image) => ({
  type: REMOVE_UPLOADING,
  image,
})

export const updatePermissions = (emails) => ({
  type: UPDATE_PERMISSIONS,
  emails,
})

export const addReceivedDocument = (document, documentOwnerId) => ({
  type: ADD_RECEIVED_DOCUMENT,
  document,
  documentOwnerId,
})

export const removeReceivedDocument = (documentId) => ({
  type: REMOVE_RECEIVED_DOCUMENT,
  documentId,
})

export const setBoardsOrder = (order) => ({
  type: SET_BOARDS_ORDER,
  order,
})

export const setUserContentSettings = (settings) => ({
  type: SET_USER_CONTENT_SETTINGS,
  settings,
})
